import PropTypes from 'prop-types'
import { Button as AntdButton } from 'antd'

const Button = (props) => {
  const {
    type,
    htmlType,
    href,
    target,
    icon,
    className,
    disabled = false,
    onClick,
  } = props

  return (
    <AntdButton
      type={type ? type : 'default'}
      {...(htmlType ? { htmlType: htmlType } : {})}
      {...(href ? { href: href } : {})}
      {...(target ? { target: target } : {})}
      icon={icon}
      className={className}
      disabled={disabled}
      {...(onClick ? { onClick } : {})}
    >
      {props.children}
    </AntdButton>
  )
}

Button.propTypes = {
  type: PropTypes.string,
  htmlType: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  icon: PropTypes.element,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export default Button
